import EventEmitter from 'eventemitter3';

const Waiting = `
<div id="content"></div>
`

const Button = `
<button id='button'> Everybody Joined </button>
`

export class ControllerWaitingScreen extends EventEmitter {
  private role:string|null = null;
  constructor() {
    super();
  }

  setRole(role:string){
     this.role = role;
  }

  public addEventListeners() {
    const content = document.getElementById('content' ) as HTMLDivElement;
    content.innerHTML = `<div>waiting as ${this.role}</div>`;

    if(this.role == 'primary'){
      content.innerHTML += Button
      const button = document.getElementById('button');
      button?.addEventListener('click',()=>{
        this.emit("room_ready")
      })
    }
  }

  public removeEventListeners() {}

  getElement() {
    return Waiting;
  }

}